import { jsxs, jsx } from "react/jsx-runtime";
const IconRocketSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M15.067 1.875a.667.667 0 0 0-.475-.476A7.502 7.502 0 0 0 6.98 3.815l-.743.882L4.5 4.278a1.852 1.852 0 0 0-2.258.905l-1.467 2.6a.667.667 0 0 0 .441.98l2.049.439a8.946 8.946 0 0 0-.37 1.623.667.667 0 0 0 .19.557L5.15 13.45a.667.667 0 0 0 .53.193 8.11 8.11 0 0 0 1.66-.327l.43 2.002a.667.667 0 0 0 .979.441l2.604-1.468a2.023 2.023 0 0 0 .916-2.203l-.446-1.84.825-.758a7.47 7.47 0 0 0 2.418-7.614ZM2.382 7.649l1.037-1.84a.55.55 0 0 1 .713-.25l1.145.277-.433.515a8.73 8.73 0 0 0-1.06 1.598l-1.402-.3Zm8.313 5.481-1.81 1.021-.287-1.336a7.56 7.56 0 0 0 1.609-1.08l.496-.456.269 1.11a.693.693 0 0 1-.277.741Zm1.076-4.643-2.456 2.257a6.515 6.515 0 0 1-3.447 1.536l-1.603-1.603a7.288 7.288 0 0 1 1.6-3.47l1.12-1.329a.642.642 0 0 0 .052-.062l.956-1.135a6.185 6.185 0 0 1 5.873-2.08 6.145 6.145 0 0 1-2.095 5.886Zm-.615-4.11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" })
    ]
  }
);
export {
  IconRocketSvg
};
